// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Figtree_39a21a', '__Figtree_Fallback_39a21a'","fontWeight":700,"fontStyle":"normal"},"className":"__className_39a21a","variable":"__variable_39a21a"};